import i18n from 'config/i18n';
import { Panel } from 'config/types';
import { BusinessChoiceType } from 'features/utils/types';
import getFirstExistingTranslation from './getFirstExistingTranslation';

export const getPanelByID = (panelId: string, panelList: Panel[]) =>
  panelList.find((panel) => panel.id === panelId);

export const getPanelName = (
  panelId: string,
  panelList: Panel[],
  businessChoice: BusinessChoiceType | undefined
) => {
  const panel = getPanelByID(panelId, panelList);
  return getFirstExistingTranslation(i18n.t, i18n, [
    `PANEL_SELECTION_panel_${panel.assetIndex}_${businessChoice}.title`,
    `PANEL_SELECTION_panel_${panel.assetIndex}.title`,
  ]);
};
